import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './readingApp/app.module';

import * as _ from 'lodash';

// if (process.env.NODE_ENV === 'alpha') {
//     enableProdMode();
// }

platformBrowserDynamic().bootstrapModule(AppModule);
